<!--
 * @Description: 
 * @Date: 2020-12-11 18:32:30
-->
<template>
  <div>
    <table-render :config="config" height="52vh" />
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { listOrderDetail } from './config/index.js';
export default {
  components: { tableRender },
  name: 'payProgress',
  props: {
    row: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  // props:['orderId','structureType'],
  data() {
    return {
      config: null
    };
  },
  computed: {
    visible: {
      set: function(v) {
        this.$emit('input', v);
      },
      get: function() {
        return this.value || false;
      }
    }
  },
  created() {
    listOrderDetail[0].childMenu[0].defaultQuery = {
      ...this.row
    };
    this.config = listOrderDetail;
  }
};
</script>

<style lang="scss" scoped>
.app-info {
  padding: 0 1.56vw;
  td {
    padding: 4px 8px;
    b {
      color: #606266;
      font-weight: 600;
    }
  }
}
</style>
